import {makeAutoObservable} from 'mobx';
import s from '../../s';
import axios from 'axios';
import {getAntiForgeryToken} from '../../../util';

declare var __fiu: string;

interface IImageResult {
    hash: string;
    w: number;
    h: number;
    debug: number;
    is_error: boolean;
}

class ImageUploadStore {
    public file: File;
    public reso_level: number = 0;

    constructor() {
        makeAutoObservable(this);
    }

    uploadImage = async () => {
        var success = true;
        try {
            s.ui.image_uploading = true;
            s.ui.image_uploaded_msg = '';
            s.ui.processing_title = 'Image Uploading';
            s.ui.processing_text = 'Please stay on this page until your image is done uploading.';
            // console.log('file bytes length', this.file.size);

            const url = '/api/img/event';
            const config = {
                headers: {
                    RequestVerificationToken: getAntiForgeryToken(),
                },
            };

            const response = await axios.post(url, this.getFormData(), config);
            const ir: IImageResult = response.data;
            console.log(response.data);

            if (!ir.hash || ir.hash?.includes('error') || ir.hash?.length !== 32 || ir.is_error) {
                // console.error('image upload failed', ir.hash ? ir.hash : 'empty');
                this.imageUploadError();
            } else {
                // console.error('image upload success', ir.hash);
                s.ui.image_uploaded_msg = '';
                s.ps.image_upload_hash3 = ir.hash;
                s.ps.override_d1_img = `https://chc-upload.s3.amazonaws.com/d/${ir.hash}.png`;
                s.ui.image_uploaded = true;
                s.ui.doRender = true;
                s.ui.update_pricing = true;
            }
        } catch (err) {
            console.error(err);
            s.ui.image_uploading = false;
            s.ps.override_d1_img = '';
            this.imageUploadError(err);
            this.cancel();
        } finally {
            s.ui.image_uploading = false;
        }
    };

    imageUploadError = (err: string = 'Error uploading image. Please try again or contact customer service.') => {
        s.ui.image_uploaded = false;
        s.ui.image_uploaded_msg = err;
        s.ui.image_upload_error = true;
        this.reso_level = 0;
        this.cancel();
    };

    cancel = () => {
        const fileInput: HTMLInputElement | null = document.querySelector('#imageUploadInput');

        if (fileInput) {
            fileInput.value = '';
        }
    };

    getFormData = (_file?: File) => {
        const formData = new FormData();
        const file = _file || this.file;

        formData.append('file', file);

        if (this.file) {
            formData.append('fileName', this.file.name);
        }

        formData.append('doc_width', s.ps.docWidth.toString());
        formData.append('doc_height', s.ps.docHeight.toString());
        formData.append('fiu', __fiu);

        return formData;
    };
}

export const imageUploadStore = new ImageUploadStore();
